(function(){
  var hdr = document.querySelector('[data-av-hdr]');
  if (!hdr) return;
  function onScroll(){ hdr.classList.toggle('is-stuck', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function closeAllMega(returnFocus){
    document.querySelectorAll('[data-av-mega-btn]').forEach(function(button){
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (returnFocus && panel && panel.contains(document.activeElement)) button.focus();
      button.setAttribute('aria-expanded', 'false');
      if (panel) { panel.classList.remove('is-open'); panel.inert = true; }
    });
  }
  document.querySelectorAll('[data-av-mega-btn]').forEach(function(button){
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    function open(){
      closeAllMega();
      if (panel) { panel.inert = false; panel.classList.add('is-open'); button.setAttribute('aria-expanded', 'true'); }
    }
    button.addEventListener('click', function(){
      if (button.getAttribute('aria-expanded') === 'true') closeAllMega(); else open();
    });
    button.addEventListener('keydown', function(event){
      if (event.key !== 'ArrowDown') return;
      event.preventDefault(); open();
      var first = panel && panel.querySelector('a,button');
      if (first) first.focus();
    });
  });
  document.addEventListener('click', function(event){
    if (!event.target.closest('.av-nav__item')) closeAllMega();
  });
  document.addEventListener('focusin', function(event){
    if (!event.target.closest('.av-nav__item')) closeAllMega();
  });
  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') closeAllMega(true);
  });

  var mnav = document.querySelector('[data-av-mnav]');
  var sw = document.querySelector('[data-av-search]');
  var si = document.querySelector('[data-av-search-input]');
  var sr = document.querySelector('[data-av-search-res]');
  var status = document.querySelector('[data-av-search-status]');
  var activeOverlay = null;
  var previousOverflow = '';

  function modal(dialog, triggers, firstFocus, afterClose){
    var returnFocus = null;
    function cleanup(restoreFocus){
      dialog.classList.remove('is-open');
      triggers.forEach(function(button){ button.setAttribute('aria-expanded', 'false'); });
      if (activeOverlay === api) { activeOverlay = null; document.body.style.overflow = previousOverflow; }
      if (afterClose) afterClose();
      if (restoreFocus && returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
      returnFocus = null;
    }
    var api = {
      open: function(trigger){
        if (dialog.open) return;
        if (activeOverlay) activeOverlay.close(false);
        closeAllMega();
        returnFocus = trigger || document.activeElement;
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        activeOverlay = api;
        document.body.style.overflow = 'hidden';
        dialog.classList.add('is-open');
        triggers.forEach(function(button){ button.setAttribute('aria-expanded', 'true'); });
        var target = firstFocus();
        if (target) target.focus({preventScroll:true});
      },
      close: function(restoreFocus){
        if (!dialog.open) return;
        dialog.close();
        cleanup(restoreFocus !== false);
      }
    };
    triggers.forEach(function(button){ button.addEventListener('click', function(){api.open(button);}); });
    dialog.addEventListener('cancel', function(event){event.preventDefault();api.close();});
    dialog.addEventListener('close', function(){if (!dialog.open && activeOverlay === api) cleanup(true);});
    return api;
  }

  var mapi;
  if (mnav) {
    var mainSlide = mnav.querySelector('[data-level="0"]');
    var slides = Array.from(mnav.querySelectorAll('[data-panel]'));
    var intoButtons = Array.from(mnav.querySelectorAll('[data-av-mnav-into]'));
    function resetSlides(){
      if (mainSlide) { mainSlide.inert = false; mainSlide.removeAttribute('aria-hidden'); }
      slides.forEach(function(slide){slide.classList.remove('is-in');slide.inert=true;slide.setAttribute('aria-hidden','true');});
      intoButtons.forEach(function(button){button.setAttribute('aria-expanded','false');});
    }
    mapi = modal(mnav, Array.from(document.querySelectorAll('[data-av-mnav-open]')), function(){
      return mnav.querySelector('.av-mnav__top [data-av-mnav-close]');
    }, resetSlides);
    mnav.querySelectorAll('[data-av-mnav-close]').forEach(function(button){button.addEventListener('click',function(){mapi.close();});});
    intoButtons.forEach(function(button){
      button.addEventListener('click', function(){
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        panel.inert = false; panel.setAttribute('aria-hidden','false'); panel.classList.add('is-in');
        button.setAttribute('aria-expanded','true');
        var back = panel.querySelector('[data-av-mnav-back]');
        if (back) back.focus({preventScroll:true});
        if (mainSlide) { mainSlide.inert = true; mainSlide.setAttribute('aria-hidden','true'); }
      });
    });
    mnav.querySelectorAll('[data-av-mnav-back]').forEach(function(button){
      button.addEventListener('click', function(){
        var panel = button.closest('[data-panel]');
        var trigger = intoButtons.find(function(item){return item.getAttribute('aria-controls') === panel.id;});
        if (mainSlide) { mainSlide.inert = false; mainSlide.removeAttribute('aria-hidden'); }
        if (trigger) { trigger.setAttribute('aria-expanded','false'); trigger.focus({preventScroll:true}); }
        panel.classList.remove('is-in'); panel.inert = true; panel.setAttribute('aria-hidden','true');
      });
    });
    mnav.addEventListener('click', function(event){
      if (event.target.closest('[data-quiz-open]')) mapi.close();
    }, true);
    window.matchMedia('(min-width:1280px)').addEventListener('change',function(event){if(event.matches)mapi.close();});
  }
  if (sw) {
    var sapi = modal(sw, Array.from(document.querySelectorAll('[data-av-search-open]')), function(){return si;});
    sw.querySelectorAll('[data-av-search-close]').forEach(function(button){button.addEventListener('click',function(){sapi.close();});});
    sw.addEventListener('click',function(event){if(event.target===sw)sapi.close();});
  }

  var timer = null;
  var request = null;
  var requestNumber = 0;
  if (si && sr && sw) {
    si.addEventListener('input', function(){
      clearTimeout(timer);
      if (request) request.abort();
      var sequence = ++requestNumber;
      var q = si.value.trim();
      sr.setAttribute('aria-busy','false');
      if (status) status.textContent = '';
      if (q.length < 2) { sr.replaceChildren(); return; }
      timer = setTimeout(function(){
        var base = (window.themeSettings || {}).rootUrl || '/';
        request = new AbortController();
        sr.setAttribute('aria-busy','true');
        if (status) status.textContent = sw.dataset.loadingText;
        fetch(base + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search', {signal:request.signal})
          .then(function(response){if(!response.ok)throw new Error('Search unavailable');return response.text();})
          .then(function(html){
            if (sequence !== requestNumber) return;
            var markup = new DOMParser().parseFromString(html,'text/html');
            var results = markup.querySelector('[data-predictive-results]');
            if (!results) throw new Error('Search unavailable');
            sr.replaceChildren.apply(sr,Array.from(results.childNodes));
            if (status) status.textContent = sw.dataset.updatedText;
          })
          .catch(function(error){
            if (error.name === 'AbortError' || sequence !== requestNumber) return;
            var link = document.createElement('a');
            link.className = 'av-search__all';
            link.href = base + 'search?q=' + encodeURIComponent(q) + '&type=product';
            link.textContent = sw.dataset.fallbackText;
            sr.replaceChildren(link);
            if (status) status.textContent = sw.dataset.fallbackText;
          })
          .finally(function(){if(sequence === requestNumber)sr.setAttribute('aria-busy','false');});
      },180);
    });
  }
})();
